<div class="flex w-full h-full justify-center">
  <div class="flex flex-col my-20">
    <p-progressSpinner class="mx-auto"></p-progressSpinner>
    <p>Authenticating...</p>
  </div>
</div>
